export default function txtTrimmer(textToClean) {
  var txt = textToClean ? textToClean.toString() : '';
  txt = txt.replace(/(\r\n|\n|\r)/gm, '').trim();
  txt = txt.replace(/ /g, '_'); // replace spaces with underscores, as requested
  return txt.replace(/(\r\n|\n|\r)/gm, '').trim();
};
